import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Force unregister ALL service workers and clear ALL caches on every load
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((reg) => reg.unregister());
  });
  caches.keys().then((names) => {
    names.forEach((name) => caches.delete(name));
  });
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<App />);